import * as React from 'react';
import ContentLoader from 'react-content-loader';

class FormLoader extends React.PureComponent {

    public render() {
        return <>
                <ContentLoader
                speed={2}
                width={'100%'}
                viewBox='0 0 350 180'
                backgroundColor='#D3D3D3'
                // foregroundColor='#041E42'
                {...this.props}
            >
                <rect x='10' y='10' rx='3' ry='3' width='100%' height='10' />
                <rect x='10' y='30' rx='3' ry='3' width='100%' height='10' />
                <rect x='10' y='50' rx='3' ry='3' width='100%' height='10' />
                <rect x='10' y='70' rx='3' ry='3' width='100%' height='10' />
                <rect x='10' y='90' rx='3' ry='3' width='100%' height='10' />
                <rect x='10' y='110' rx='3' ry='3' width='100%' height='10' />
                <rect x='10' y='130' rx='3' ry='3' width='100%' height='10' />
                <rect x='10' y='150' rx='3' ry='3' width='35' height='10' />
            </ContentLoader>
        </>;
    }
}

export default FormLoader;